import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const CargarExcelConsulta = () => {

  const [loading, setLoading] = useState(false);

  const handleFile = async (file) => {

    try {

      setLoading(true);

      const formData = new FormData();

      formData.append('archivo', file);

      const response = await axios.post(
        'https://wwwa.isepsantafe.net.ar/expedientes/importar-excel-consulta',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
// console.log(response)
      Swal.fire({
        icon: 'success',
        title: 'Archivo importado',
        text: `Se importaron ${response.data.cantidad} registros`,
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo importar el archivo',
      });

    } finally {

      setLoading(false);
    }
  };

  const onDrop = async (e) => {

    e.preventDefault();

    const file = e.dataTransfer.files[0];

    if (!file) {
      return;
    }

    await handleFile(file);
  };

  const onChangeInput = async (e) => {

    const file = e.target.files[0];

    if (!file) {
      return;
    }

    await handleFile(file);
  };

  return (

    <div
      onDrop={onDrop}
      onDragOver={(e) => e.preventDefault()}
      style={{
        border: '2px dashed #999',
        padding: '50px',
        borderRadius: '10px',
        textAlign: 'center',
        background: '#fafafa',
      }}
    >

      <h3>
        Importar Excel
      </h3>

      <p>
        Arrastrá el archivo Excel aquí
      </p>

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={onChangeInput}
      />

      <br />
      <br />

      {
        loading &&
        <p>
          Importando archivo...
        </p>
      }

    </div>
  );
};

export default CargarExcelConsulta;